import {
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibStackOverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex,
  cilListRich,
  cilMoney,
  cilNotes
} from '@coreui/icons'
import {
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl
} from '@coreui/icons'
import {
  cilApps,
  cilArrowRight,
  cilBan,
  cilBasket,
  cilBell,
  cilCalculator,
  cilCalendar,
  cilCalendarCheck,
  cilChartPie,
  cilCheck,
  cilCheckCircle,
  cilChevronBottom,
  cilChevronRight,
  cilChevronTop,
  cilClock,
  cilCloudDownload,
  cilCoffee,
  cilCommentSquare,
  cilCursor,
  cilDescription,
  cilDollar,
  cilDrop,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilEuro,
  cilFile,
  cilGlobeAlt,
  cilGrid,
  cilInbox,
  cilJustifyCenter,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilLocationPin,
  cilLockLocked,
  cilLoop,
  cilMagnifyingGlass,
  cilMediaPlay,
  cilMediaStop,
  cilMoon,
  cilOptions,
  cilPaperPlane,
  cilPencil,
  cilPeople,
  cilPuzzle,
  cilSend,
  cilSettings,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilStar,
  cilSun,
  cilTask,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilWallet,
  cilWarning,
  cilXCircle,
  cilBusAlt,
  cilYen,
  cilChevronDoubleUp,
  cilBuilding
} from '@coreui/icons'
import { logo } from './logo'

export const iconsSet = Object.assign(
  {},
  { logo },
  {
    cilApps,
    cilArrowRight,
    cilBan,
    cilBasket,
    cilBell,
    cilCalculator,
    cilCalendar,
    cilCalendarCheck,
    cilChartPie,
    cilCheck,
    cilCheckCircle,
    cilChevronBottom,
    cilChevronRight,
    cilChevronTop,
    cilClock,
    cilCloudDownload,
    cilCoffee,
    cilCommentSquare,
    cilCursor,
    cilDescription,
    cilDollar,
    cilDrop,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEuro,
    cilFile,
    cilGlobeAlt,
    cilGrid,
    cilInbox,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilLocationPin,
    cilLockLocked,
    cilLoop,
    cilMagnifyingGlass,
    cilMediaPlay,
    cilMediaStop,
    cilMoon,
    cilOptions,
    cilPaperPlane,
    cilPencil,
    cilPeople,
    cilPuzzle,
    cilSend,
    cilSettings,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilStar,
    cilSun,
    cilTask,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilWallet,
    cilWarning,
    cilXCircle,
    cilBusAlt,
    cilListRich,
    cilYen,
    cilChevronDoubleUp,
    cilBuilding,
    cilMoney,
    cilNotes
  },
  {
    cifUs,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl
  },
  {
    cibFacebook,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibGithub,
    cibStackOverflow,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard,
    cibCcVisa,
    cibStripe,
    cibPaypal,
    cibGooglePay,
    cibCcAmex
  }
)
